import Vue from "vue";
import Router from "vue-router";
import HomePage from "@/components/pages/home";
import movieDetails from "@/components/pages/movieDetails";
import movieListing from "@/components/pages/movieListing";
import seatLayout from "@/components/pages/seatLayout/seatlayout";
import payment from "@/components/pages/payment";
import VistaPayment from "@/components/pages/ExternalPayments/VistaPayment";
import RtsPayment from "@/components/pages/ExternalPayments/RtsPayment";
import createShowpayment from "@/components/pages/createShowpayment";
import confirmScreen from "@/components/pages/confirmScreen";
import confirmScreenVista from "@/components/pages/ExternalConfirmScreen/confirmScreenVista";
import confirmScreenRts from "@/components/pages/ExternalConfirmScreen/confirmScreenRts";
import failedPayment from "@/components/pages/failedPayment";
import specialScreening from "@/components/pages/specialScreening";
import regularMovies from "@/components/pages/regularMovies";
import searchResult from "@/components/pages/searchResultCinema";
import createScreen from "@/components/pages/createScreen";
import cinemaCreateScreen from "@/components/pages/cinemaCreateScreen";
import createScreenList from "@/components/pages/createScreenList";
import nowShowingList from "@/components/pages/NowShowingList";
import specialScreeningList from "@/components/pages/specialScreeningList";
import miniFestivalsList from "@/components/pages/miniFestivalsList";
import hiw from "@/components/pages/howItsWorks";
import hiwWesbite from "@/components/pages/howItsWorkswebiste";
import noSearchFound from "@/components/pages/noSearchFound";
import cinemapage from "@/components/pages/cinemapage";

import aboutus from "@/components/pages/aboutus";
import helpPage from "@/components/pages/help-page";
import faqs from "@/components/pages/faqs";
import privacyPolicy from "@/components/pages/privacyPolicy";
import cookiesprivacyPolicy from "@/components/pages/cookiesprivacyPolicy";
import termsCondition from "@/components/pages/termsCondition";
import termscondition from "@/components/pages/terms-condition";
import termsConditionTicket from "@/components/pages/terms-condition-ticket";
import profile from "@/components/pages/profile";
import myAccount from "@/components/pages/myaccount";
import mySpecialScreening from "@/components/pages/mySpecialScreening";
import myNotification from "@/components/pages/myNotification";
import myFavourites from "@/components/pages/myFavourites";
import myTransaction from "@/components/pages/myTransaction";
import myWallet from "@/components/pages/myWallet";
import offersAndPromotion from "@/components/pages/offers&promotion";
import error404 from "@/components/pages/error404";
import comingSoon from "@/components/pages/comingSoon";
import contactUs from "@/components/pages/contactUs";
import NewsRoom from "@/components/pages/NewsRoom";

// import offers&promotions from '@/components/pages/offers&promotion'

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Home",
      component: HomePage
    },
    {
      path: "/movie",
      name: "movieDetails",
      component: movieDetails
    },

    {
      path: "/failedPayment",
      name: "failedPayment",
      component: failedPayment
    },
    {
      path:
        "/specialScreening/:categoryId/:movieId/:content_lang_id/:cinemaId?",
      name: "specialScreening",
      component: specialScreening
    },
    {
      path: "/seatLayout/:ss_id/:screen_id/:md_id",
      name: "seatLayout",
      component: seatLayout
    },
    {
      path: "/confirmScreen/:show_booking_id/:category_id",
      name: "confirmScreen",
      component: confirmScreen
    },
    {
      path: "/vista-confirmScreen/:show_booking_id",
      name: "confirmScreenVista",
      component: confirmScreenVista
    },
    {
      path: "/rts-confirmScreen/:rts_reserve_id",
      name: "confirmScreenRts",
      component: confirmScreenRts
    },
    {
      path: "/regularMovies/:movie_id/:content_lang_id",
      name: "regularMovies",
      component: regularMovies
    },
    {
      path: "/createScreen/:movie_id/:content_lang_id",
      name: "createScreen",
      component: createScreen
    },
    {
      path: "/cinemaScreen/:cinemaId",
      name: "cinemaScreen",
      component: cinemaCreateScreen
    },
    {
      path: "/terms-condition-ticket/",
      name: "termsConditionTicket",
      component: termsConditionTicket
    },
    {
      path: "/help-page/",
      name: "helpPage",
      component: helpPage
    },
    {
      path: "/createScreenList",
      name: "createScreenList",
      component: createScreenList
    },
    {
      path: "/nowShowingList",
      name: "nowShowingList",
      component: nowShowingList
    },
    {
      path: "/specialScreeningList",
      name: "specialScreeningList",
      component: specialScreeningList
    },

    {
      path: "/miniFestivalList",
      name: "miniFestivalList",
      component: miniFestivalsList
    },
    {
      path: "/noSearchFound",
      name: "noSearchFound",
      component: noSearchFound
    },
    {
      path: "/cinema-page",
      name: "cinemapage",
      component: cinemapage
    },

    {
      path: "/how-it-works",
      name: "howItsWorks",
      component: hiw
    },
    {
      path: "/hiw",
      name: "hiw",
      component: hiwWesbite
    },
    {
      path: "/aboutus",
      name: "aboutus",
      component: aboutus
    },
    {
      path: "/faqs",
      name: "faqs",
      component: faqs
    },
    {
      path: "/privacyPolicy",
      name: "privacyPolicy",
      component: privacyPolicy
    },
    {
      path: "/cookiesprivacyPolicy",
      name: "cookiesprivacyPolicy",
      component: cookiesprivacyPolicy
    },
    {
      path: "/termsCondition",
      name: "termsCondition",
      component: termsCondition
    },
    {
      path: "/searchResult",
      name: "searchResult",
      component: searchResult
    },
    {
      path: "/payment/:reservation_id/:category_id",
      name: "payment",
      component: payment
    },
    {
      path: "/v-payment/:orderId/",
      name: "v-payment",
      component: VistaPayment
    },
    {
      path: "/rts-payment/:orderId",
      name: "rts-payment",
      component: RtsPayment
    },
    {
      path: "/create-show-payment/:reservation_id/:category_id",
      name: "createpayment",
      component: createShowpayment
    },
    {
      path: "/terms-condition",
      name: termscondition,
      component: termscondition
    },
    {
      path: "/coming-soon",
      name: comingSoon,
      component: comingSoon
    },
    {
      path: "/offers-promotions",
      name: offersAndPromotion,
      component: offersAndPromotion
    },
    {
      path: "/feedback",
      name: contactUs,
      component: contactUs
    },
    {
      path: "/newsroom",
      name: NewsRoom,
      component: NewsRoom
    },
    // Nested Routes
    {
      path: "/profile/",
      component: profile,
      children: [
        {
          path: "",
          redirect: "/profile/myaccount"
        },
        {
          path: "myaccount",
          component: myAccount
        },
        {
          path: "myspecialscreening",
          component: mySpecialScreening
        },
        {
          path: "myNotification",
          component: myNotification
        },
        {
          path: "myFavourites",
          component: myFavourites
        },
        {
          path: "myTransaction",
          component: myTransaction
        },
        {
          path: "myWallet",
          component: myWallet
        }

        //
      ]
    },
    {
      path: "*",
      name: "error404",
      component: error404
    }
  ],

  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js